module.exports = __webpack_public_path__ + "img/headshot1.603869ea.jpg";